import React from 'react';

const Separator = () => <hr width="100%" style={{ opacity: 0.4 }} />;

export default Separator;
